import React from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface FieldItemProps {
    label: string
    value: any
    icon?: React.ReactNode
}

const FieldItem: React.FC<FieldItemProps> = ({ label, value, icon }) => {
    if (!value && value !== 0) return null

    return (
        <div className="group grid grid-cols-3 gap-2 py-1.5 px-2 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100 last:border-b-0">
            <div className="flex items-center gap-1.5">
                {icon && (
                    <div className="text-gray-400 group-hover:text-primary transition-colors w-4 h-4">
                        {icon}
                    </div>
                )}
                <Typogaphy className="font-medium text-sm text-gray-600">
                    {label}:
                </Typogaphy>
            </div>
            <Typogaphy className="col-span-2 text-sm text-gray-800 font-medium">
                {value}
            </Typogaphy>
        </div>
    )
}

export default FieldItem
